import React, { FC, useState, useEffect } from "react";
import axios from "axios";
import Heading from "components/Heading/Heading";
import { RentripsURL } from "utils/request";

export interface Statistic {
  id: string;
  heading: string;
  subHeading: string;
}

const FOUNDER_DEMO: Statistic[] = [
  {
    id: "1",
    heading: "200,000",
    subHeading:
      "Terdapat kurang lebih 100.000 pelanggan yang mampir setiap harinya.",
  },
  {
    id: "2",
    heading: "100,000+",
    subHeading: "Terdaftar lebih dari 100.000 akun (sejak Juli 2021)",
  },
  {
    id: "3",
    heading: "150+",
    subHeading: "Terdata lebih dari 150 lokasi di Indonesia",
  },
];

export interface SectionStatisticProps {
  className?: string;
}

const SectionStatistic: FC<SectionStatisticProps> = ({ className = "" }) => {
  const [status, setStatus] = useState<Statistic[]>(FOUNDER_DEMO);

  const getData = async () => {
    const { data } = await axios.get(RentripsURL +"/api/etc/status");
    setStatus(data);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className={`nc-SectionStatistic relative ${className}`}>
      <Heading desc="Kami adalah startup yang berdiri secara independen, akan selalu ada update & fitur-fitur baru namun tetap menjaga kenyamanan pelayanan.">
        🚀 Fakta Hebat Kami
      </Heading>
      <div className="grid md:grid-cols-2 gap-6 lg:grid-cols-3 xl:gap-8">
        {status.map((item, index) => (
          <div
            key={index}
            className="p-6 bg-neutral-50 dark:bg-neutral-800 rounded-2xl dark:border-neutral-800"
          >
            <h3 className="text-2xl font-semibold leading-none text-neutral-900 md:text-3xl dark:text-neutral-200">
              {item.heading}
            </h3>
            <span className="block text-sm text-neutral-500 mt-3 sm:text-base dark:text-neutral-400">
              {item.subHeading}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionStatistic;
